import { render, staticRenderFns } from "./previewSlider.vue?vue&type=template&id=03bc4c05"
import script from "./previewSlider.vue?vue&type=script&lang=js"
export * from "./previewSlider.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports